import {
  GET_PO_CONFIG_SUCCESS,
} from "redux/actions/action-type";

const initialState = {
  poSplitDisabledLocations: [],
  poAddDisabledLocations: [],
};

const poConfigReducer = (state = initialState, action) => {
  if (action.type === GET_PO_CONFIG_SUCCESS)
    return { ...state, poSplitDisabledLocations: action.payload.poSplitDisabledLocations || [], poAddDisabledLocations: action.payload.poAddDisabledLocations || [] };
  return state;
};

export default poConfigReducer;
